import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';
import { designSystem } from '@/styles/styles';

function SvgComponent(props) {
    return (
        <Svg width={35} height={81} viewBox="0 0 35 81" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <Path
                d="M34.25.75v79.5H14.809V25.43L1.857 32.457l-1.107.6V13.405l.398-.212L24.44.838l.165-.088h9.645z"
                fill={designSystem.colors.neutral900}
                stroke={ds.colorValue.icon.brand}
                strokeWidth={1.5}
            />
        </Svg>
    );
}

export default SvgComponent;
